<div class="row">
    <ng-container *ngFor="let item of items">
        <div class="col-12"
            [ngClass]="item?.alignment" 
            [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding"  
        >
            <div class="pb-map-iframe-container" style="position: relative;">
                <div class="pb-map-iframe rounded shadow" [innerHTML]="item?.content | safeHtml">
                </div>

                <div class="pb-map-information px-10">
                    <div class="bg-white w-100 py-10 rounded shadow px-10">
                        <ng-container *ngFor="let information of item?.information">
                            <div *ngIf="information?.type == 'HEADING'" [innerHTML]="information?.content"></div>
                            <p class="mb-0 font-size-14 fg-light-blue" *ngIf="information?.type == 'TEXT'">{{ information?.content }}</p>          
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
